import classNames from 'classnames'
import React from 'react'

interface ExampleListProps {
  width?: string
  height?: string
  showBadge?: boolean
}

export const ExampleList: React.FC<ExampleListProps> = ({
  width,
  height,
  showBadge = false,
}) => {
  const imageList = [
    'https://cdn.fastseller.shop/common/good_example1.png',
    'https://cdn.fastseller.shop/common/good_example2.png',
    'https://cdn.fastseller.shop/common/good_example3.png',
    'https://cdn.fastseller.shop/common/bad_example1.png',
    'https://cdn.fastseller.shop/common/bad_example2.png',
  ]
  return (
    <>
      {/* 예시 이미지들 */}
      <div className="flex  justify-center gap-1 ">
        {imageList.map((image, index) => (
          <div
            key={index}
            className={classNames(' rounded-[10px] relative', {
              [`${width}`]: width,
              'w-[130px] ': !width,
              [`${height}`]: height,
              'h-[130px] ': !height,
            })}
          >
            <img
              src={image}
              alt=""
              className="w-full h-full object-cover rounded-[10px]"
            />
          </div>
        ))}
      </div>
    </>
  )
}
